// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://rsms.me/inter/inter.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
  Takes a css-key, an optional css-value and a theme-value
  usage : theme("box-shadow", 0 0 30px 5px, "primary") => box-shadow: 0 0 30px 5px primary,
  theme("color", "primary") => color: primary
 */
.login {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.login .loginBackground {
  position: absolute;
  z-index: 1;
}
.login .loginBackground:first-of-type {
  top: 0;
  right: 0;
  max-width: 52%;
}
.login .loginBackground:nth-of-type(2) {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 72.85%;
}
.login .loginBackground:nth-of-type(3) {
  bottom: 0;
  left: 0;
  max-width: 12%;
}
.login .loginBackground:nth-of-type(4) {
  bottom: 26%;
  left: 4%;
  max-width: 8%;
}
.login .loginElements {
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 0 15px;
  text-align: center;
}
.login .logo {
  max-width: 495px;
  width: 100%;
  margin-bottom: 50px;
}
.login .form {
  max-width: 470px;
  margin: 0 auto;
  text-align: initial;
}
.login .googleButtonContainer {
  text-align: center;
}
.login .googleButton {
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  border: 0;
  margin: 10px 0;
  padding: 0;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}
.dark .login .googleButton {
  background: #4285F4;
}
.light .login .googleButton {
  background: #ffffff;
}
.dark .login .googleButton {
  color: rgba(60, 60, 59, 0.8);
}
.light .login .googleButton {
  color: rgba(60, 60, 59, 0.8);
}
.login .googleButton:active {
  background: #4285F4;
}
.login .googleButtonLabel {
  margin: 0 16px 0 16px;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
}
.login .copyright {
  display: flex;
  position: absolute;
  bottom: 10px;
  right: 15px;
  font-size: 8px;
}
.login .copyright .miniLogo {
  margin: 0 0 0 5px;
}

.otpForm {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 350px;
  margin: auto;
}
.otpForm .otpFormHeader {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.otpForm .otpFormHeader .otpTitle {
  font-size: 24px;
  margin-left: 5px;
}
.otpForm .otpDescription {
  text-align: center;
  font-size: 14px;
}
.otpForm .otpError {
  font-size: 14px;
}
.otpForm .otpInputsContainer {
  margin-top: 15px;
  margin-bottom: 15px;
}
.otpForm .otpInputsContainer .otpInput {
  width: 45px;
  height: 60px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
  font-size: 36px;
  border-radius: 8px;
  border: none;
  outline: none;
}
.otpForm .otpInputsContainer .otpInput:disabled {
  opacity: 0.5;
}
.otpForm label {
  align-self: center;
  margin-top: 15px;
  font-size: 15px;
}
.otpForm .buttonsContainer {
  margin-top: 15px;
}
.otpForm .buttonsContainer .goBackButton {
  margin-right: 10px;
}
.otpForm .buttonsContainer .resendButton {
  margin-left: 10px;
}

.error-template {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5em;
  margin-bottom: 1em;
}
.error-template .error-number {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 42px;
  font-weight: 800;
}
.error-template .error-number.has-technis-logo {
  max-width: 12em;
}
.error-template .error-number:not(.has-technis-logo) {
  line-height: 0.8;
}
.error-template .error-number .technis-logo {
  width: 40%;
  height: 40%;
}
.error-template .error-number .normal-error-code {
  font-size: 120px;
}
.error-template .error-message {
  text-align: center;
  font-size: 28px;
  font-weight: 300;
  margin: 1em 0;
}
.error-template .buttons button:not(:last-child) {
  margin-right: 0.5em;
}

.errorBoundary {
  flex-direction: column;
  display: flex;
  align-items: center;
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  justify-content: center;
}
.errorBoundary h1 {
  margin-bottom: 50px;
}
.errorBoundary--buttons {
  align-items: center;
  display: flex;
}
.errorBoundary--buttons button {
  margin: 15px;
}

.global-search {
  display: flex;
  flex-direction: column;
  padding-left: 100px;
  padding-right: 100px;
}
.global-search-content {
  margin-top: 70px;
}
.global-search-home {
  flex: 1;
  align-items: center;
  justify-content: center;
}
.global-search .results-table {
  margin-bottom: 15px;
}
.dark .global-search .results-table-row {
  background: #ffffff;
}
.light .global-search .results-table-row {
  background: #ffffff;
}
.global-search .actions {
  display: flex;
  flex-direction: column;
}
.global-search .buttons-container {
  margin-top: 100px;
  display: flex;
  gap: 15px;
}

.modal-tab-content {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  padding-bottom: 40px;
}

.modal-input-label {
  margin-top: 20px;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
}

.modal-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.modal-footer .extra-button {
  margin-right: 15px;
}
.modal-footer .cancel-button {
  margin-right: 15px;
  height: 51px;
  width: 88px;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  margin-top: 25px;
}
.badges .badge-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px;
  padding: 3px 18px;
  border-radius: 6px;
}
.badges .badge-container svg:hover {
  cursor: pointer;
}
.badges .badge-container .badge-label {
  margin-right: 8px;
  font-size: 16px;
  font-weight: 700;
}

.form-input-container {
  margin-bottom: 16px;
}

.email-input-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.remove-icon {
  margin-left: 16px;
}

.form-input {
  margin-top: 8px;
  margin-bottom: 8px;
}

.emails-header {
  display: flex;
  justify-content: space-between;
}

.search-wrapper {
  display: flex;
  flex-direction: column;
  padding-left: 100px;
  padding-right: 100px;
  margin-top: 50px;
}
.search-wrapper .search-bar-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
}
.search-wrapper .search-bar-container .container {
  display: flex;
  flex-direction: row;
}
.search-wrapper .search-bar-container .container .user-button {
  height: 60px;
  width: 145px;
  margin-left: 6px;
}
.dark .search-wrapper .search-bar-container .container .user-button-blue {
  background: #1E2BF7;
}
.light .search-wrapper .search-bar-container .container .user-button-blue {
  background: #1E2BF7;
}
.search-wrapper .results-table {
  margin-bottom: 15px;
}
.dark .search-wrapper .results-table-row {
  background: #ffffff;
}
.light .search-wrapper .results-table-row {
  background: #ffffff;
}
.search-wrapper .actions {
  display: flex;
  flex-direction: column;
}

.support-data-modal-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.json-reader-modal-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
}

.code-block-container {
  margin-bottom: 16px;
}

.daterange-header {
  display: flex;
  justify-content: space-between;
}

.main-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.main-layout .header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
}
.main-layout .logo {
  margin-top: 20px;
  margin-left: 20px;
}

.widget-builder {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
}
.widget-builder .button-content {
  display: flex;
  align-items: center;
  text-transform: capitalize;
}
.widget-builder .button-content img {
  margin-right: 5px;
}
.widget-builder header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  padding: 16px;
  border-bottom: 1px solid #ddd;
}
.widget-builder header .title {
  font-size: 18px;
  margin-bottom: 0;
  font-weight: normal;
}
.widget-builder header > div {
  display: inline-flex;
  gap: 10px;
}
.widget-builder header .button-group {
  display: flex;
}
.widget-builder header .button-group > button:nth-child(1) {
  margin-right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.widget-builder header .button-group > button:nth-child(2) {
  margin-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}
.widget-builder .container {
  display: flex;
  height: 100%;
  width: 100%;
}
.widget-builder .container .editor {
  flex: 1;
  height: 100%;
  z-index: 1;
  position: relative;
}
.widget-builder .container .editor > * {
  height: 100%;
}
.widget-builder .container .preview {
  width: 100%;
  height: 100%;
  border-left: 1px solid #ddd;
}
.widget-builder .container .preview.hidden {
  opacity: 0;
}
.widget-builder .container iframe {
  display: flex;
  width: 100%;
  height: 100%;
  border: 0;
}
.widget-builder .jsoneditor {
  border: none;
}
.widget-builder .jsoneditor .jsoneditor-poweredBy {
  display: none;
}
.widget-builder .jsoneditor-menu {
  background-color: #c0c0c0;
  border-bottom: #c0c0c0;
}
.widget-builder .gpt-pane {
  height: 100%;
  border-bottom: 1px solid #ddd;
}
.widget-builder .gpt-pane .gpt-prompt {
  width: 100%;
  height: 100%;
  outline: none;
  border: none;
  padding: 8px;
  font-family: inherit;
}
.widget-builder .gpt-pane .gpt-prompt:focus {
  outline: none;
  border: none;
}
.widget-builder .gpt-pane .gpt-button-wrapper {
  position: absolute;
  bottom: 14px;
  right: 14px;
  border-radius: 8px;
  overflow: hidden;
  padding: 2px;
  background: linear-gradient(270deg, #8f4dea, #588de7, #1ed2e3);
  background-size: 400% 400%;
  transition: padding 0.2s ease, bottom 0.2s ease, right 0.2s ease, opacity 0.2s ease;
  padding: 0px;
  opacity: 0.5;
  box-shadow: rgba(0, 0, 0, 0.5);
}
.widget-builder .gpt-pane .gpt-button-wrapper:not([aria-disabled=true]) {
  bottom: 13px;
  right: 13px;
  padding: 2px;
  opacity: 0.8;
  animation: gptButtonAnim 5s ease infinite;
}
.widget-builder .gpt-pane .gpt-button-wrapper:not([aria-disabled=true]):hover {
  opacity: 1;
  right: 12px;
  bottom: 12px;
  padding: 4px;
  animation: gptButtonAnim 2s ease infinite;
}
.widget-builder .gpt-pane .gpt-button-wrapper[aria-busy=true] {
  animation: gptButtonAnim 2s ease infinite;
}
.widget-builder .gpt-pane button {
  background: transparent;
}
.widget-builder .gpt-pane button svg.wand-icon {
  color: inherit;
  width: 16px;
  height: 16px;
  margin-left: 6px;
}
.widget-builder .preview-pages {
  display: block;
  overflow-x: scroll;
  white-space: nowrap;
  padding: 0;
  margin: 0;
  border-left: 1px solid #ddd;
  font-size: 0.8em;
  background: #fff;
}
.widget-builder .preview-pages li {
  list-style: none;
  display: inline-block;
  padding: 4px;
  margin: 2px 2px 0 2px;
  cursor: pointer;
}
.widget-builder .preview-pages li:hover:not(.active) {
  color: #4153af;
  border-radius: 4px;
}
.dark .widget-builder .preview-pages li:hover:not(.active) {
  background: rgba(179, 157, 219, 0.45);
}
.light .widget-builder .preview-pages li:hover:not(.active) {
  background: rgba(179, 157, 219, 0.45);
}
.widget-builder .preview-pages li.active {
  border-bottom: 2px solid #4153af;
  color: #4153af;
}
.widget-builder div[role=Resizer] {
  background: #000;
  opacity: 0;
  z-index: 1;
  box-sizing: border-box;
  background-clip: padding-box;
}
.widget-builder div[role=Resizer]:hover {
  opacity: 0.2;
  transition: all 0.2 ease;
}
.widget-builder div[role=Resizer].horizontal {
  height: 11px;
  margin: -5px 0;
  border-top: 5px solid rgba(255, 255, 255, 0);
  border-bottom: 5px solid rgba(255, 255, 255, 0);
  cursor: row-resize;
  width: 100%;
}
.widget-builder div[role=Resizer].horizontal:hover {
  border-top: 5px solid rgba(0, 0, 0, 0.5);
  border-bottom: 5px solid rgba(0, 0, 0, 0.5);
}
.widget-builder div[role=Resizer].vertical {
  width: 11px;
  margin: 0 -5px;
  border-left: 5px solid rgba(255, 255, 255, 0);
  border-right: 5px solid rgba(255, 255, 255, 0);
  cursor: col-resize;
}
.widget-builder div[role=Resizer].vertical:hover {
  border-left: 5px solid rgba(0, 0, 0, 0.5);
  border-right: 5px solid rgba(0, 0, 0, 0.5);
}
.widget-builder div[role=Resizer].disabled {
  cursor: not-allowed;
}
.widget-builder div[role=Resizer].disabled:hover {
  border-color: transparent;
}
.widget-builder .lightbeam {
  position: absolute;
  z-index: 1;
  pointer-events: none;
  opacity: 0;
  animation: lightbeam 0.6s ease-out forwards;
}
.widget-builder .lightbeam svg {
  width: 100%;
  height: 100%;
}
.widget-builder .preview-update-indicator {
  position: absolute;
  z-index: 1;
  pointer-events: none;
  border: 10px solid #588de7;
  animation: fadeOut 0.6s ease forwards;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.widget-builder .modal {
  z-index: 999;
}

.save-as-dropdown-menu-item {
  padding: 8px;
  margin-right: 8px;
  border-radius: 8px;
  cursor: pointer;
}
.dark .save-as-dropdown-menu-item:hover {
  background: rgba(60, 60, 59, 0.1);
}
.light .save-as-dropdown-menu-item:hover {
  background: rgba(60, 60, 59, 0.1);
}

@keyframes gptButtonAnim {
  0% {
    background-position: 10% 0%;
  }
  50% {
    background-position: 91% 100%;
  }
  100% {
    background-position: 10% 0%;
  }
}
@keyframes lightbeam {
  0% {
    opacity: 0;
    scale: 0.2;
  }
  1% {
    opacity: 1;
    scale: 0.3;
  }
  100% {
    opacity: 0;
    scale: 3;
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
    border-width: 10px;
  }
  100% {
    opacity: 0;
    border-width: 0px;
  }
}
.access-actions {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

* {
  box-sizing: border-box;
}

html,
body {
  height: auto;
}
.dark html,
.dark body {
  background: #F7F7FE;
}
.light html,
.light body {
  background: #F7F7FE;
}

html,
body,
#root {
  margin: 0;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  background-attachment: fixed;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
}
.dark html,
.dark body,
.dark #root {
  color: rgba(60, 60, 59, 0.8);
}
.light html,
.light body,
.light #root {
  color: rgba(60, 60, 59, 0.8);
}

.search-input {
  width: 740px;
  margin-bottom: 25px;
}

.icon-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: baseline;
}
.icon-button-cursor {
  cursor: pointer;
}
.icon-button .icon-button-label {
  margin-top: 2px;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
}`, "",{"version":3,"sources":["webpack://./src/styles/theme.scss","webpack://./src/styles/login.scss","webpack://./src/styles/index.scss","webpack://./src/styles/variable.scss","webpack://./src/styles/error.scss","webpack://./src/styles/errorBoundary.scss","webpack://./src/styles/globalSearch.scss","webpack://./src/styles/usersSearch.scss","webpack://./src/styles/mixins.scss","webpack://./src/styles/searchWrapper.scss","webpack://./src/styles/installationSearch.scss","webpack://./src/styles/mainLayout.scss","webpack://./src/styles/widgetBuilder.scss","webpack://./src/styles/access.scss"],"names":[],"mappings":"AAuCA;;;;EAAA;ACvCA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;ACOF;ADLE;EACE,kBAAA;EACA,UAAA;ACOJ;ADLI;EACE,MAAA;EACA,QAAA;EACA,cAAA;ACON;ADJI;EACE,SAAA;EACA,SAAA;EACA,2BAAA;EACA,iBAAA;ACMN;ADHI;EACE,SAAA;EACA,OAAA;EACA,cAAA;ACKN;ADFI;EACE,WAAA;EACA,QAAA;EACA,aAAA;ACIN;ADAE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;ACEJ;ADCE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;ACCJ;ADEE;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;ACAJ;ADGE;EACE,kBAAA;ACDJ;ADIE;EACE,eAAA;EAGA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,2CAAA;ACJJ;AFvBI;EACE,mBAAA;AEyBN;AF1BI;EACE,mBAAA;AE4BN;AF7BI;EACE,4BAAA;AE+BN;AFhCI;EACE,4BAAA;AEkCN;ADNI;EACE,mBExDQ;ADgEd;ADJE;EACE,qBAAA;EACA,iCAAA;EACA,gBAAA;ACMJ;ADHE;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;ACKJ;ADHI;EACE,iBAAA;ACKN;;ADAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;ACGF;ADDE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;ACGJ;ADDI;EACE,eAAA;EACA,gBAAA;ACGN;ADCE;EACE,kBAAA;EACA,eAAA;ACCJ;ADEE;EACE,eAAA;ACAJ;ADGE;EACE,gBAAA;EACA,mBAAA;ACDJ;ADGI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;ACDN;ADGM;EACE,YAAA;ACDR;ADME;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;ACJJ;ADOE;EACE,gBAAA;ACLJ;ADOI;EACE,kBAAA;ACLN;ADQI;EACE,iBAAA;ACNN;;AE5JA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AF+JF;AE7JE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AF+JJ;AE7JI;EACE,eAAA;AF+JN;AE5JI;EACE,gBAAA;AF8JN;AE3JI;EACE,UAAA;EACA,WAAA;AF6JN;AE1JI;EACE,gBAAA;AF4JN;AExJE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AF0JJ;AErJM;EACE,mBAAA;AFuJR;;AGlMA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,uBAAA;AHqMF;AGnME;EACE,mBAAA;AHqMJ;AGlME;EACE,mBAAA;EACA,aAAA;AHoMJ;AGlMI;EACE,YAAA;AHoMN;;AIxNA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AJ2NF;AIzNE;EACE,gBAAA;AJ2NJ;AIxNE;EACE,OAAA;EACA,mBAAA;EACA,uBAAA;AJ0NJ;AIvNE;EACE,mBAAA;AJyNJ;AF5LI;EACE,mBAAA;AE8LN;AF/LI;EACE,mBAAA;AEiMN;AIxNE;EACE,aAAA;EACA,sBAAA;AJ0NJ;AIvNE;EACE,iBAAA;EACA,aAAA;EACA,SAAA;AJyNJ;;AKzPA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;AL4PF;;AKzPA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AL4PF;;AKzPA;ECbE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AN0QF;AK7PE;EACE,kBAAA;AL+PJ;AK5PE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AL8PJ;;AK1PA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AL6PF;AK3PE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AL6PJ;AK3PI;EACE,eAAA;AL6PN;AK1PI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;AL4PN;;AKvPA;EACE,mBAAA;AL0PF;;AKvPA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AL0PF;;AKvPA;EACE,iBAAA;AL0PF;;AKvPA;EACE,eAAA;EACA,kBAAA;AL0PF;;AKvPA;EACE,aAAA;EACA,8BAAA;AL0PF;;AOpUA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;APuUF;AOrUE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;APuUJ;AOrUI;EACE,aAAA;EACA,mBAAA;APuUN;AOrUM;EACE,YAAA;EACA,YAAA;EACA,gBAAA;APuUR;AF7SI;EACE,mBAAA;AE+SN;AFhTI;EACE,mBAAA;AEkTN;AOpUE;EACE,mBAAA;APsUJ;AFtTI;EACE,mBAAA;AEwTN;AFzTI;EACE,mBAAA;AE2TN;AOrUE;EACE,aAAA;EACA,sBAAA;APuUJ;;AOnUA;ED1CE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;ANiXF;;AOtUA;ED9CE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EC6CA,gBAAA;AP4UF;;AOzUA;EACE,mBAAA;AP4UF;;AQjYA;EACE,aAAA;EACA,8BAAA;ARoYF;;AStYA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;ATyYF;ASvYE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;ATyYJ;AStYE;EACE,gBAAA;EACA,iBAAA;ATwYJ;;AUtZA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AVyZF;AUvZE;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;AVyZJ;AUvZI;EACE,iBAAA;AVyZN;AUrZE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBTpBI;ESqBJ,aAAA;EACA,6BAAA;AVuZJ;AUrZI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AVuZN;AUpZI;EACE,oBAAA;EACA,SAAA;AVsZN;AUnZI;EACE,aAAA;AVqZN;AUnZM;EACE,eAAA;EACA,0BAAA;EACA,6BAAA;AVqZR;AUnZM;EACE,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,+CAAA;AVqZR;AUhZE;EACE,aAAA;EACA,YAAA;EACA,WAAA;AVkZJ;AUhZI;EACE,OAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AVkZN;AUhZM;EACE,YAAA;AVkZR;AU9YI;EACE,WAAA;EACA,YAAA;EACA,2BAAA;AVgZN;AU9YM;EACE,UAAA;AVgZR;AU5YI;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AV8YN;AU1YE;EACE,YAAA;AV4YJ;AU1YI;EACE,aAAA;AV4YN;AUxYE;EACE,yBAAA;EACA,sBAAA;AV0YJ;AUvYE;EACE,YAAA;EACA,6BAAA;AVyYJ;AUvYI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;AVyYN;AUvYM;EACE,aAAA;EACA,YAAA;AVyYR;AUrYI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,8DAAA;EACA,0BAAA;EACA,mFAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;AVuYN;AUrYM;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EAEA,yCAAA;AVsYR;AUrYQ;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yCAAA;AVuYV;AUnYM;EACE,yCAAA;AVqYR;AUjYI;EACE,uBAAA;AVmYN;AUjYM;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AVmYR;AU9XE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;AVgYJ;AU9XI;EACE,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AVgYN;AU9XM;EAEE,cT9KI;ES+KJ,kBAAA;AV+XR;AFzgBI;EACE,qCAAA;AE2gBN;AF5gBI;EACE,qCAAA;AE8gBN;AUlYM;EACE,gCAAA;EACA,cTpLI;ADwjBZ;AU/XE;EACE,gBAAA;EACA,UAAA;EACA,UAAA;EACA,sBAAA;EACA,4BAAA;AViYJ;AU/XI;EACE,YAAA;EACA,wBAAA;AViYN;AU9XI;EACE,YAAA;EACA,cAAA;EACA,4CAAA;EACA,+CAAA;EACA,kBAAA;EACA,WAAA;AVgYN;AU/XM;EACE,wCAAA;EACA,2CAAA;AViYR;AU7XI;EACE,WAAA;EACA,cAAA;EACA,6CAAA;EACA,8CAAA;EACA,kBAAA;AV+XN;AU7XM;EACE,yCAAA;EACA,0CAAA;AV+XR;AU3XI;EACE,mBAAA;AV6XN;AU5XM;EACE,yBAAA;AV8XR;AUzXE;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,UAAA;EACA,2CAAA;AV2XJ;AU1XI;EACE,WAAA;EACA,YAAA;AV4XN;AUxXE;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,0BAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AV0XJ;AUvXE;EACE,YAAA;AVyXJ;;AUrXA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVwXF;AF1lBI;EACE,iCAAA;AE4lBN;AF7lBI;EACE,iCAAA;AE+lBN;;AUvXA;EACE;IACE,2BAAA;EV0XF;EUxXA;IACE,6BAAA;EV0XF;EUxXA;IACE,2BAAA;EV0XF;AACF;AUvXA;EACE;IACE,UAAA;IACA,UAAA;EVyXF;EUvXA;IACE,UAAA;IACA,UAAA;EVyXF;EUvXA;IACE,UAAA;IACA,QAAA;EVyXF;AACF;AUtXA;EACE;IACE,UAAA;IACA,kBAAA;EVwXF;EUtXA;IACE,UAAA;IACA,iBAAA;EVwXF;AACF;AWlrBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AXorBF;;AAxqBA;EACE,sBAAA;AA2qBF;;AAxqBA;;EAEE,YAAA;AA2qBF;AFlpBI;;EACE,mBAAA;AEqpBN;AFtpBI;;EACE,mBAAA;AEypBN;;AA/qBA;;;EAGE,SAAA;EACA,gCAAA;EACA,eAAA;EAEA,gBAAA;EACA,4BAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;AAirBF;AF/pBI;;;EACE,4BAAA;AEmqBN;AFpqBI;;;EACE,4BAAA;AEwqBN;;AAxrBA;EACE,YAAA;EACA,mBAAA;AA2rBF;;AAxrBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AA2rBF;AAzrBE;EACE,eAAA;AA2rBJ;AAxrBE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA0rBJ","sourcesContent":["@import \"variable\";\n\n$themes: (\n  dark: (\n    font: $gray-80,\n    primary-color: $dark-violet,\n    secondary-color: $deep-lilac,\n    background: $main-background,\n    box-shadow: $gray-30,\n    light: $white,\n    highlight-color: $cold-purple,\n    highlight-color-45: $cold-purple-45,\n    report-generator-button: $light-blue,\n    report-generator-border: $gray-10,\n    report-generator-title: $dark-blue,\n    report-generator-subtitle: #BBBDC6,\n    dropdown-label: $gray,\n    google-button-backgroud: $google-blue,\n    bulk-invite-button-backgroud: $deep-blue,\n  ),\n  light: (\n    font: $gray-80,\n    primary-color: $dark-violet,\n    secondary-color: $deep-lilac,\n    background: $main-background,\n    box-shadow: $gray-30,\n    light: $white,\n    highlight-color: $cold-purple,\n    highlight-color-45: $cold-purple-45,\n    report-generator-button: $light-blue,\n    report-generator-border: $gray-10,\n    report-generator-title: $dark-blue,\n    report-generator-subtitle: #BBBDC6,\n    dropdown-label: $gray,\n    google-button-backgroud: $white,\n    bulk-invite-button-backgroud: $deep-blue,\n  ),\n);\n\n/**\n  Takes a css-key, an optional css-value and a theme-value\n  usage : theme(\"box-shadow\", 0 0 30px 5px, \"primary\") => box-shadow: 0 0 30px 5px primary,\n  theme(\"color\", \"primary\") => color: primary\n */\n@mixin theme($css-key, $args...) {\n  @each $theme-name, $color in $themes {\n    .#{$theme-name} & {\n      #{$css-key}: if(length($args) == 2, nth($args, 1), null) map-get(map-get($themes, $theme-name), if(length($args) == 2, nth($args, 2), nth($args, 1)));\n    }\n  }\n}\n\n@mixin transparentize($css-key, $theme-color, $transparency: 0) {\n  @each $theme-name, $color in $themes {\n    .#{$theme-name} & {\n      #{$css-key}: transparentize(map-get(map-get($themes, $theme-name), $theme-color), $transparency);\n    }\n  }\n}\n\n@mixin darken($css-key, $theme-color, $transparency: 0) {\n  @each $theme-name, $color in $themes {\n    .#{$theme-name} & {\n      #{$css-key}: darken(map-get(map-get($themes, $theme-name), $theme-color), $transparency);\n    }\n  }\n}\n\n@mixin gradient-text($gradient-fonts) {\n  @each $theme-name, $color in $themes {\n    .#{$theme-name} & {\n      $gradients: map-get(map-get($themes, $theme-name), $gradient-fonts);\n      background-image: linear-gradient(nth($gradients, 1), nth($gradients, 2));\n      color: transparent;\n      -webkit-background-clip: text;\n    }\n  }\n}\n",".login {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n\n  .loginBackground {\n    position: absolute;\n    z-index: 1;\n\n    &:first-of-type {\n      top: 0;\n      right: 0;\n      max-width: 52%;\n    }\n\n    &:nth-of-type(2) {\n      bottom: 0;\n      left: 50%;\n      transform: translateX(-50%);\n      max-width: 72.85%;\n    }\n\n    &:nth-of-type(3) {\n      bottom: 0;\n      left: 0;\n      max-width: 12%;\n    }\n\n    &:nth-of-type(4) {\n      bottom: 26%;\n      left: 4%;\n      max-width: 8%;\n    }\n  }\n\n  .loginElements {\n    position: relative;\n    z-index: 2;\n    width: 100%;\n    margin: 0 15px;\n    text-align: center;\n  }\n\n  .logo {\n    max-width: 495px;\n    width: 100%;\n    margin-bottom: 50px;\n  }\n\n  .form {\n    max-width: 470px;\n    margin: 0 auto;\n    text-align: initial;\n  }\n\n  .googleButtonContainer {\n    text-align: center;\n  }\n\n  .googleButton {\n    font-size: 14px;\n    @include theme(\"background\", \"google-button-backgroud\");\n    @include theme(\"color\", \"font\");\n    display: inline-flex;\n    align-items: center;\n    border: 0;\n    margin: 10px 0;\n    padding: 0;\n    border-radius: 2px;\n    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);\n\n    &:active {\n      background: $google-blue;\n    }\n  }\n\n  .googleButtonLabel {\n    margin: 0 16px 0 16px;\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 500;\n  }\n\n  .copyright {\n    display: flex;\n    position: absolute;\n    bottom: 10px;\n    right: 15px;\n    font-size: 8px;\n\n    .miniLogo {\n      margin: 0 0 0 5px;\n    }\n  }\n}\n\n.otpForm {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 350px;\n  margin: auto;\n\n  .otpFormHeader {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n\n    .otpTitle {\n      font-size: 24px;\n      margin-left: 5px;\n    }\n  }\n\n  .otpDescription {\n    text-align: center;\n    font-size: 14px;\n  }\n\n  .otpError {\n    font-size: 14px;\n  }\n\n  .otpInputsContainer {\n    margin-top: 15px;\n    margin-bottom: 15px;\n\n    .otpInput {\n      width: 45px;\n      height: 60px;\n      margin-left: 5px;\n      margin-right: 5px;\n      text-align: center;\n      font-size: 36px;\n      border-radius: 8px;\n      border: none;\n      outline: none;\n\n      &:disabled {\n        opacity: 0.5;\n      }\n    }\n  }\n\n  label {\n    align-self: center;\n    margin-top: 15px;\n    font-size: 15px;\n  }\n\n  .buttonsContainer {\n    margin-top: 15px;\n\n    .goBackButton {\n      margin-right: 10px;\n    }\n\n    .resendButton {\n      margin-left: 10px;\n    }\n  }\n}\n","@import \"mixins\";\n@import \"variable\";\n@import \"theme\";\n@import \"login\";\n@import \"error\";\n@import \"errorBoundary\";\n@import \"globalSearch\";\n@import \"usersSearch\";\n@import \"searchWrapper\";\n@import \"installationSearch\";\n@import \"mainLayout\";\n@import \"widgetBuilder\";\n@import \"access\";\n@import url(\"https://rsms.me/inter/inter.css\");\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  height: auto;\n  @include theme(\"background\", \"background\");\n}\n\nhtml,\nbody,\n#root {\n  margin: 0;\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  @include transparentize(\"color\", \"font\");\n  font-weight: 400;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  height: 100%;\n  width: 100%;\n}\n\n.search-input {\n  width: 740px;\n  margin-bottom: 25px;\n}\n\n.icon-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  align-self: baseline;\n\n  &-cursor {\n    cursor: pointer;\n  }\n\n  .icon-button-label {\n    margin-top: 2px;\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 36px;\n  }\n}\n","$white: #ffffff;\n$black: #000000;\n\n$gray: #3c3c3b;\n$gray-80: rgba($gray, 0.8);\n$gray-60: rgba($gray, 0.6);\n$gray-30: rgba($gray, 0.3);\n$gray-10: rgba($gray, 0.1);\n\n$dark-blue: #4153af;\n$light-blue: #588de7;\n$blue: #005aee;\n$electric-violet: #4c00ee;\n$purple: #8f4dea;\n$white-lilac: #f5f7fb;\n$deep-lilac: #7e57c2;\n$dark-violet: #363670;\n$cold-purple: #b39ddb;\n$cold-purple-15: rgba($cold-purple, 0.15);\n$cold-purple-45: rgba($cold-purple, 0.45);\n$google-blue: #4285F4;\n$main-background: #F7F7FE;\n$deep-blue: #1E2BF7;\n",".error-template {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 5em;\n  margin-bottom: 1em;\n\n  .error-number {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    font-size: 42px;\n    font-weight: 800;\n\n    &.has-technis-logo {\n      max-width: 12em;\n    }\n\n    &:not(.has-technis-logo) {\n      line-height: 0.8;\n    }\n\n    .technis-logo {\n      width: 40%;\n      height: 40%;\n    }\n\n    .normal-error-code {\n      font-size: 120px;\n    }\n  }\n\n  .error-message {\n    text-align: center;\n    font-size: 28px;\n    font-weight: 300;\n    margin: 1em 0;\n  }\n\n  .buttons {\n    button {\n      &:not(:last-child) {\n        margin-right: 0.5em;\n      }\n    }\n  }\n}\n",".errorBoundary {\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  width: 100vw;\n  height: 100vh;\n  position: absolute;\n  left: 0;\n  top: 0;\n  justify-content: center;\n\n  h1 {\n    margin-bottom: 50px;\n  }\n\n  &--buttons {\n    align-items: center;\n    display: flex;\n\n    button {\n      margin: 15px;\n    }\n  }\n}\n",".global-search {\n  display: flex;\n  flex-direction: column;\n  padding-left: 100px;\n  padding-right: 100px;\n\n  &-content {\n    margin-top: 70px;\n  }\n\n  &-home {\n    flex: 1;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .results-table {\n    margin-bottom: 15px;\n  }\n\n  .results-table-row {\n    @include theme(\"background\", \"light\");\n  }\n\n  .actions {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .buttons-container {\n    margin-top: 100px;\n    display: flex;\n    gap: 15px;\n  }\n}\n",".modal-tab-content {\n  display: flex;\n  flex-direction: column;\n  padding-top: 20px;\n  padding-bottom: 40px;\n}\n\n.modal-input-label {\n  margin-top: 20px;\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.modal-footer {\n  @include modal-footer;\n\n  .extra-button {\n    margin-right: 15px;\n  }\n\n  .cancel-button {\n    margin-right: 15px;\n    height: 51px;\n    width: 88px;\n  }\n}\n\n.badges {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 25px;\n\n  .badge-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 4px;\n    padding: 3px 18px;\n    border-radius: 6px;\n\n    svg:hover {\n      cursor: pointer;\n    }\n\n    .badge-label {\n      margin-right: 8px;\n      font-size: 16px;\n      font-weight: 700;\n    }\n  }\n}\n\n.form-input-container {\n  margin-bottom: 16px;\n}\n\n.email-input-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.remove-icon {\n  margin-left: 16px;\n}\n\n.form-input {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.emails-header {\n  display: flex;\n  justify-content: space-between;\n}\n","@mixin modal-footer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n",".search-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-left: 100px;\r\n  padding-right: 100px;\r\n  margin-top: 50px;\r\n\r\n  .search-bar-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    margin-top: 20px;\r\n\r\n    .container {\r\n      display: flex;\r\n      flex-direction: row;\r\n\r\n      .user-button {\r\n        height: 60px;\r\n        width: 145px;\r\n        margin-left: 6px;\r\n\r\n        &-blue {\r\n          @include theme(\"background\", \"bulk-invite-button-backgroud\");\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .results-table {\r\n    margin-bottom: 15px;\r\n  }\r\n\r\n  .results-table-row {\r\n    @include theme(\"background\", \"light\");\r\n  }\r\n\r\n  .actions {\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n}\r\n\r\n.support-data-modal-footer {\r\n  @include modal-footer;\r\n}\r\n\r\n.json-reader-modal-footer {\r\n  @include modal-footer;\r\n  margin-top: 20px;\r\n}\r\n\r\n.code-block-container {\r\n  margin-bottom: 16px;\r\n}",".daterange-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n",".main-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-right: 20px;\n  }\n\n  .logo {\n    margin-top: 20px;\n    margin-left: 20px;\n  }\n}\n",".widget-builder {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n\n  .button-content {\n    display: flex;\n    align-items: center;\n    text-transform: capitalize;\n\n    img {\n      margin-right: 5px;\n    }\n  }\n\n  header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: $white;\n    padding: 16px;\n    border-bottom: 1px solid #ddd;\n\n    .title {\n      font-size: 18px;\n      margin-bottom: 0;\n      font-weight: normal;\n    }\n\n    > div {\n      display: inline-flex;\n      gap: 10px;\n    }\n\n    .button-group {\n      display: flex;\n\n      & > button:nth-child(1) {\n        margin-right: 0;\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n      & > button:nth-child(2) {\n        margin-left: 0;\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n        border-left: 1px solid rgba(255, 255, 255, 0.2);\n      }\n    }\n  }\n\n  .container {\n    display: flex;\n    height: 100%;\n    width: 100%;\n\n    .editor {\n      flex: 1;\n      height: 100%;\n      z-index: 1;\n      position: relative;\n\n      > * {\n        height: 100%;\n      }\n    }\n\n    .preview {\n      width: 100%;\n      height: 100%;\n      border-left: 1px solid #ddd;\n\n      &.hidden {\n        opacity: 0;\n      }\n    }\n\n    iframe {\n      display: flex;\n      width: 100%;\n      height: 100%;\n      border: 0;\n    }\n  }\n\n  .jsoneditor {\n    border: none;\n\n    .jsoneditor-poweredBy {\n      display: none;\n    }\n  }\n\n  .jsoneditor-menu {\n    background-color: #c0c0c0;\n    border-bottom: #c0c0c0;\n  }\n\n  .gpt-pane {\n    height: 100%;\n    border-bottom: 1px solid #ddd;\n\n    .gpt-prompt {\n      width: 100%;\n      height: 100%;\n      outline: none;\n      border: none;\n      padding: 8px;\n      font-family: inherit;\n\n      &:focus {\n        outline: none;\n        border: none;\n      }\n    }\n\n    .gpt-button-wrapper {\n      position: absolute;\n      bottom: 14px;\n      right: 14px;\n      border-radius: 8px;\n      overflow: hidden;\n      padding: 2px;\n      background: linear-gradient(270deg, #8f4dea, #588de7, #1ed2e3);\n      background-size: 400% 400%;\n      transition: padding 0.2s ease, bottom 0.2s ease, right 0.2s ease, opacity 0.2s ease;\n      padding: 0px;\n      opacity: 0.5;\n      box-shadow: rgba(0, 0, 0, 0.5);\n\n      &:not([aria-disabled=\"true\"]) {\n        bottom: 13px;\n        right: 13px;\n        padding: 2px;\n        opacity: 0.8;\n\n        animation: gptButtonAnim 5s ease infinite;\n        &:hover {\n          opacity: 1;\n          right: 12px;\n          bottom: 12px;\n          padding: 4px;\n          animation: gptButtonAnim 2s ease infinite;\n        }\n      }\n\n      &[aria-busy=\"true\"] {\n        animation: gptButtonAnim 2s ease infinite;\n      }\n    }\n\n    button {\n      background: transparent;\n\n      svg.wand-icon {\n        color: inherit;\n        width: 16px;\n        height: 16px;\n        margin-left: 6px;\n      }\n    }\n  }\n\n  .preview-pages {\n    display: block;\n    overflow-x: scroll;\n    white-space: nowrap;\n    padding: 0;\n    margin: 0;\n    border-left: 1px solid #ddd;\n    font-size: 0.8em;\n    background: #fff;\n\n    li {\n      list-style: none;\n      display: inline-block;\n      padding: 4px;\n      margin: 2px 2px 0 2px;\n      cursor: pointer;\n\n      &:hover:not(.active) {\n        @include theme(\"background\", \"highlight-color-45\");\n        color: $dark-blue;\n        border-radius: 4px;\n      }\n\n      &.active {\n        border-bottom: 2px solid $dark-blue;\n        color: $dark-blue;\n      }\n    }\n  }\n\n  div[role=\"Resizer\"] {\n    background: #000;\n    opacity: 0;\n    z-index: 1;\n    box-sizing: border-box;\n    background-clip: padding-box;\n\n    &:hover {\n      opacity: 0.2;\n      transition: all 0.2 ease;\n    }\n\n    &.horizontal {\n      height: 11px;\n      margin: -5px 0;\n      border-top: 5px solid rgba(255, 255, 255, 0);\n      border-bottom: 5px solid rgba(255, 255, 255, 0);\n      cursor: row-resize;\n      width: 100%;\n      &:hover {\n        border-top: 5px solid rgba(0, 0, 0, 0.5);\n        border-bottom: 5px solid rgba(0, 0, 0, 0.5);\n      }\n    }\n\n    &.vertical {\n      width: 11px;\n      margin: 0 -5px;\n      border-left: 5px solid rgba(255, 255, 255, 0);\n      border-right: 5px solid rgba(255, 255, 255, 0);\n      cursor: col-resize;\n\n      &:hover {\n        border-left: 5px solid rgba(0, 0, 0, 0.5);\n        border-right: 5px solid rgba(0, 0, 0, 0.5);\n      }\n    }\n\n    &.disabled {\n      cursor: not-allowed;\n      &:hover {\n        border-color: transparent;\n      }\n    }\n  }\n\n  .lightbeam {\n    position: absolute;\n    z-index: 1;\n    pointer-events: none;\n    opacity: 0;\n    animation: lightbeam 0.6s ease-out forwards;\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .preview-update-indicator {\n    position: absolute;\n    z-index: 1;\n    pointer-events: none;\n    border: 10px solid #588de7;\n    animation: fadeOut 0.6s ease forwards;\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n  }\n\n  .modal {\n    z-index: 999;\n  }\n}\n\n.save-as-dropdown-menu-item {\n  padding: 8px;\n  margin-right: 8px;\n  border-radius: 8px;\n  cursor: pointer;\n\n  &:hover {\n    @include theme(\"background\", \"report-generator-border\");\n  }\n}\n\n@keyframes gptButtonAnim {\n  0% {\n    background-position: 10% 0%;\n  }\n  50% {\n    background-position: 91% 100%;\n  }\n  100% {\n    background-position: 10% 0%;\n  }\n}\n\n@keyframes lightbeam {\n  0% {\n    opacity: 0;\n    scale: 0.2;\n  }\n  1% {\n    opacity: 1;\n    scale: 0.3;\n  }\n  100% {\n    opacity: 0;\n    scale: 3;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n    border-width: 10px;\n  }\n  100% {\n    opacity: 0;\n    border-width: 0px;\n  }\n}\n",".access-actions {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
